<template>
  <div class="description-field scrollbar" :style="{ height }" @click.stop="handleClick" v-tooltip:top="'Click to edit description'">
    <div class="description-field__content">
      {{ text || '(no description)' }}
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

defineProps({
  text: {
    type: String,
    default: '',
  },
  height: {
    type: String,
    default: '80px',
  },
  clickable: {
    type: Boolean,
    default: false,
  },
  data: {
    type: [Object, String, Number],
    default: null,
  },
});

const emit = defineEmits(['click']);

function handleClick() {
  emit('click');
}
</script>

<style lang="scss" scoped>
.description-field {
  overflow-y: auto;
  overflow-x: hidden;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  font-style: italic;
  padding-top: 4px;
  color:rgb(4, 52, 124);
  cursor: pointer;
  border-top: 1px solid #d0d0d0;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;

  .description-field__content {
    word-break: break-word;
    overflow-wrap: break-word;
  }
}
</style>
